module.exports = __webpack_public_path__ + "img/92.4.NH3-N.d89b4b28.png";